import { notesStyles } from "@waytek/Overrides/Widgets/OrderDetails/OrderDetailsNotes";
import { colorPalette, fontFamilyAlt, mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

notesStyles.wrapper = {
    ...notesStyles.wrapper,
    css: css`
        ${mediaQueriesBP.minLG} {
            padding-left: 40px;
        }

        ${mediaQueriesBP.maxLG} {
            margin-top: 40px;
        }

        ${mediaQueriesBP.maxMD} {
            margin-bottom: 40px;
        }
    `,
};

notesStyles.titleText = {
    ...notesStyles.titleText,
    css: css`
        font-size: 18px;
        border-bottom: 3px solid ${colorPalette.common.global.industrialTaupe};
        padding-bottom: 4px;
        line-height: 1.78;
        font-weight: bold;
        margin-bottom: 20px;
    `,
};

notesStyles.notesText = {
    ...notesStyles.notesText,
    css: css`
        font-family: ${fontFamilyAlt};
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.71;
        letter-spacing: normal;
    `,
};
